import React, { useState, useEffect, useMemo } from "react";
import EditItemCategoryModal from "../components/addItemEditModal";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const ModifySupplier = () => {
   useAuthRedirect();
  const { sCode, itemCode, sName } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(""); 
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({
    price: "",
    disc: "",
    pf: "",
    gst: ""
  });
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////
      const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
        const permsLoaded = !!rawPerms;
        
        //✅ Permission checks (safe even if perms not yet loaded; will be false)
        const canEdit = hasPermission("Supplier With Item", "edit");
        /////////////////////////////////////////////////////////////

  const ratingLabels = ["0", "1", "2", "3"];

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
         Swal.fire({
                        title: "Fetching Supplier Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Category Code...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_fetchSubData?sCode=${sCode}`);
        const items = response.data.modifySupplier;
  
        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            sName: item.supplierMaster_name,
            address1: item.supplierMaster_addressline1,
            address2: item.supplierMaster_addressline2,
            city: item.supplierMaster_city,
            pinCode: item.supplierMaster_pincode,
            phone: item.supplierMaster_phoneNumber,
            email: item.supplierMaster_email,
            fax: item.supplierMaster_faxNumber,
            pan: item.supplierMaster_webSite,
            gst: item.supplierMaster_taxpercentage,
            rcNo: item.supplierMaster_rcNumber,
            rcDate: item.supplierMaster_rcDate,
            gstNo: item.supplierMaster_cstNumber,
            gstDate: item.supplierMaster_cstDate,
            disc: item.supplierMaster_DiscountPercentage,
            taxType: item.supplierMaster_taxtype,
            payment: item.supplierMaster_paymentMethod,
            delivery: item.supplierMaster_deliveryMethod,
            pf: item.supplierMaster_PFPercentage,
            insurance: item.supplierMaster_insuranceMethod,
            supplierMaster: item.supplierMaster_type,
            ecc: item.supplierMaster_eccNumber,
            remarks: item.supplierMaster_remarks,
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            sName: storeReqHeader1.sName,
            address1: storeReqHeader1.address1,
            address2: storeReqHeader1.address2,
            city: storeReqHeader1.city,
            pinCode: storeReqHeader1.pinCode,
            phone: storeReqHeader1.phone,
            email: storeReqHeader1.email,
            gst: storeReqHeader1.gst,
            fax: storeReqHeader1.fax,
            pan: storeReqHeader1.pan,
            rcNo: storeReqHeader1.rcNo,
            rcDate: storeReqHeader1.rcDate,
            gstNo: storeReqHeader1.gstNo,
            gstDate: storeReqHeader1.gstDate,
            disc: storeReqHeader1.disc,
            taxType: storeReqHeader1.taxType,
            payment: storeReqHeader1.payment,
            delivery: storeReqHeader1.delivery,
            pf: storeReqHeader1.pf,
            insurance: storeReqHeader1.insurance,
            supplierMaster: storeReqHeader1.supplierMaster,
            ecc: storeReqHeader1.ecc,
            remarks: storeReqHeader1.remarks,
          });
        }
        Swal.close();
      } catch (error) {
        Swal.close();
                     console.error("Error fetching Supplier Details. Please try again:", error);
                     Swal.fire({
                       icon: "error",
                       title: "Oops!",
                       text: "Error fetching Supplier Details. Please try again",
                     });
      }
    };
  
    {canEdit && (
    fetchSupplierDetails()
    )}
}, [sCode]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  
 const handleSubmit = async (e) => {
  e.preventDefault();

  // === VALIDATION START ===
  if (!(formData.sName || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your name!",
    });
    return;
  }

  if (!(formData.address1 || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your Address!",
    });
    return;
  }

  if (!(formData.city || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your City!",
    });
    return;
  }

  if (!(formData.pinCode || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your Pincode!",
    });
    return;
  }

  if (!(formData.phone || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your Phone Number!",
    });
    return;
  }

  if (!(formData.email || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your Email!",
    });
    return;
  }

  if (!(formData.fax || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter Your Fax Number!",
    });
    return;
  }

  if (!(formData.pan || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter PAN Number!",
    });
    return;
  }

  if (!(formData.rcNo || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter TIN Number!",
    });
    return;
  }

  if (!(formData.rcDate || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Select RC Date!",
    });
    return;
  }

  if (!(formData.gstNo || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Enter GST No!",
    });
    return;
  }

  if (!(formData.gstDate || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Select GST Date!",
    });
    return;
  }

  if (!(formData.taxType || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Select Your Tax Type!",
    });
    return;
  }

  // === Tax Validation (only if GST is selected) ===
if ((formData.taxType || "").toString().trim() === "GST") {
  if (formData.gst === "" || formData.gst === null || formData.gst === undefined) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Enter Your Tax Percentage!",
    });
    return;
  }

  const taxValue = Number(formData.gst);
  if (isNaN(taxValue) || taxValue < 0 || taxValue > 100) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Tax",
      text: "Tax Percentage must be a number between 0 and 100.",
    });
    return;
  }
}

// === Discount Validation ===
if (formData.disc === "" || formData.disc === null || formData.disc === undefined) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter Your Discount Percentage!",
  });
  return;
}

const discValue = Number(formData.disc);
if (isNaN(discValue) || discValue < 0 || discValue > 100) {
  Swal.fire({
    icon: "warning",
    title: "Invalid Discount",
    text: "Discount Percentage must be a number between 0 and 100.",
  });
  return;
}

// === PF Validation ===
if (formData.pf === "" || formData.pf === null || formData.pf === undefined) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter Your PF Percentage!",
  });
  return;
}

const pfValue = Number(formData.pf);
if (isNaN(pfValue) || pfValue < 0 || pfValue > 100) {
  Swal.fire({
    icon: "warning",
    title: "Invalid PF",
    text: "PF Percentage must be a number between 0 and 100.",
  });
  return;
}


  if (!(formData.ecc || "").trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Enter Your ECC Number!",
    });
    return;
  }

 

  // === VALIDATION END ===

  const payload = {
    sName: formData.sName,
    address1: formData.address1,
    address2: formData.address2,
    city: formData.city,
    pinCode: formData.pinCode,
    phone: formData.phone,
    email: formData.email,
    gst: formData.gst,
    fax: formData.fax,
    pan: formData.pan,
    rcNo: formData.rcNo,
    rcDate: formData.rcDate,
    gstNo: formData.gstNo,
    gstDate: formData.gstDate,
    disc: formData.disc,
    taxType: formData.taxType,
    payment: formData.payment,
    delivery: formData.delivery,
    pf: formData.pf,
    insurance: formData.insurance,
    supplierMaster: formData.supplierMaster,
    ecc: formData.ecc,
    remarks: formData.remarks,
    sCode: sCode,
  };
  console.log(payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      "https://rfs2.infraconsoft.net.in/api/supplier_Datamodify",
      payload
    );
    Swal.fire("Success", response.data.message, "success");
    navigate(`/inventory/supplierMasterView`);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire("Error", error.response.data.message, "error");
    } else {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  }
};

  if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
          <h2 className="add-txt">Supplier With Item -  Modify</h2>
          <Link to='/inventory/supplierMasterView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Name :</label>
                <input type="text" name="sName" value={formData.sName} onChange={handleInputChange}/>
              </div>
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="sCode" value={sCode} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={formData.address1} onChange={handleInputChange}/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={formData.address2} onChange={handleInputChange} />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={formData.city} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>PinCode :</label>
                <input type="number" name="pinCode" value={formData.pinCode} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone :</label>
                <input type="number" name="phone" value={formData.phone} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Email :</label>
                <input type="text" name="email" value={formData.email} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Fax :</label>
                <input type="text" name="fax" value={formData.fax} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>PAN :</label>
                <input type="text" name="pan" value={formData.pan} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>TIN Number :</label>
                <input type="text" name="rcNo" value={formData.rcNo} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>RC Date :</label>
                 <input
  type="date"
  name="rcDate"
  value={formData.rcDate ? formData.rcDate.slice(0, 10) : ''} 
  onChange={handleInputChange}
/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>GST Number :</label>
                <input type="text" name="gstNo" value={formData.gstNo} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>GST Date :</label>
                <input
  type="date"
  name="gstDate"
  value={formData.gstDate ? formData.gstDate.slice(0, 10) : ''} 
  onChange={handleInputChange}
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Tax Type :</label>
                <select name = "taxType"  value={formData.taxType} onChange={handleInputChange}>
                    <option value="">--Select--</option>
                    <option value="GST">GST</option>
                    <option value="NO TAX">NO TAX</option>
                </select>
              </div>
              <div className="form-group">
                <label>Tax % :</label>
                <input type="number" name="gst" value={formData.gst} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Discount % :</label>
                <input type="number" name="disc" value={formData.disc} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>PF % :</label>
                <input type="number" name="pf" value={formData.pf} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Payment :</label>
                <select name = "payment"  value={formData.payment} onChange={handleInputChange}>
                <option value="Immediate">Immediate</option>
                  <option value="30 Days">30 Days</option>
                  <option value="60 Days">60 Days</option>
                  <option value="Against Perform">Against Perform</option>
                  <option value="After Installation">After Installation</option>
                  <option value="Through Bank">Through Bank</option>
                </select>
              </div>
              <div className="form-group">
                <label>Delivery :</label>
                <select name = "delivery"  value={formData.delivery} onChange={handleInputChange}>
                <option value="Door">Door</option>
                <option value="Collect By Us">Collect By Us</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance :</label>
                <select name = "insurance"  value={formData.insurance} onChange={handleInputChange}>
                <option value="Not Applicable">Not Applicable</option>
                  <option value="Our A/c">Our A/c</option>
                  <option value="Your A/c">Your A/c</option>
                </select>
              </div>
              <div className="form-group">
                <label>ECC Number :</label>
                <input type="text" name="ecc" value={formData.ecc} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Supplier Type :</label>
                <select name = "supplierMaster"  value={formData.supplierMaster} onChange={handleInputChange}>
                <option value="Vendor-Approved">Vendor-Approved</option>
                <option value="Vendor-Non-Approved">Vendor-Non-Approved</option>
                </select>
              </div>
            </div>


          
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModifySupplier;
